import isAfter from 'utils/time/isAfter';
import isBefore from 'utils/time/isBefore';
import isSameDay from 'utils/time/isSameDay';

export function isEnrolledAt({
  dateParam,
  arrivalDate,
  radiationDate,
}: {
  dateParam?: Date;
  arrivalDate?: Date;
  radiationDate?: Date;
}): boolean {
  const date = dateParam || new Date();
  return (
    (!arrivalDate ||
      isAfter(date, arrivalDate) ||
      isSameDay(date, arrivalDate)) &&
    (!radiationDate || isBefore(date, radiationDate))
  );
}
